<template>
  <div style="width: 100%; min-height: 100vh; background: #ffffff">
    <div class="pageTop" style="position: fixed; top: 0; left: 0; right: 0; height: 46px; line-height: 46px; text-align: center; color: white; font-size: 18px; background: url(/img/counter/top-bg.webp) no-repeat #084ccb; z-index: 1000;">
      <img src="/static/image/nav_chevron_back.bb0f0ac706614ab578365b31d203927a.png" alt="" style="width: 16px; height: 16px; position: absolute; left: 15px; top: 50%; transform: translateY(-50%); cursor: pointer;" @click="$router.back()" />
      {{ $t('Betting Record') }}
      <div v-if="api_type" class="platform-select-btn" style="position: absolute; right: 15px; top: 50%; transform: translateY(-50%); cursor: pointer; font-size: 14px; padding: 4px 12px;  border-radius: 16px;" @click="showPlatformSelect = !showPlatformSelect">
        {{ $t('Select Platform') }}
      </div>
    </div>
    <div style="height: 46px"></div>
    
    <!-- 平台选择下拉菜单 -->
    <div v-if="showPlatformSelect && api_type" class="platform-select-dropdown" style="position: fixed; top: 46px; right: 5px; z-index: 1001; background: #fff; border-radius: 8px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); padding: 10px; min-width: 0px; max-height: 770px; overflow-y: auto;">
      <!-- 去除重复的平台 (移除了原本写死的“全平台”，统一用 uniquePlatforms 渲染) -->
      <div v-for="platform in uniquePlatforms" :key="platform.name" class="platform-option" style="padding: 8px 12px; cursor: pointer; border-radius: 4px; white-space: nowrap;" @click="selectPlatform(platform.name)">
        {{ platform.name }}
      </div>
    </div>
    
    <div class="fixed-header" style="width: 100%; min-width: 250px; margin: 0 auto; position: fixed; top: 46px; left: 50%; transform: translateX(-50%); z-index: 999; background: #fff; box-sizing: border-box; padding: 10px;">
      <!-- 日期筛选 -->
      <div class="date-filter">
        <div class="date-item" :class="{ 'active': date == 1 }" @click="selectDate(1)">{{ $t('Today') }}</div>
        <div class="date-item" :class="{ 'active': date == 5 }" @click="selectDate(5)">{{ $t('Yesterday') }}</div>
        <div class="date-item" :class="{ 'active': date == 6 }" @click="selectDate(6)">{{ $t('This Week') }}</div>
        <div class="date-item" :class="{ 'active': date == 7 }" @click="selectDate(7)">{{ $t('Last Week') }}</div>
      </div>
      
      <!-- 总计信息 -->
      <div class="total-info">
        <div class="total-item">
          <span class="total-label">{{ $t('Total (Bets)') }}</span>
          <span class="total-value">{{ totalBets }}</span>
        </div>
        <div class="total-item">
          <span class="total-label">{{ $t('Valid Bet') }}</span>
          <span class="total-value">{{ fmtMoney(validBet) }}</span>
        </div>
        <div class="total-item">
          <span class="total-label">{{ $t('Win/Loss') }}</span>
          <span class="total-value" :class="{ 'negative': winLoss < 0, 'positive': winLoss > 0 }">{{ fmtMoney(winLoss) }}</span>
        </div>
      </div>
    </div>
    
    <div style="width: 100%; min-width: 250px; background: #fff; border-radius: 10px; box-sizing: border-box; padding: 10px; padding-top: 150px; min-height: 90vh;">
      <!-- 游戏平台列表：只展示有投注的平台 -->
      <div class="game-list" v-if="gameList.length > 0">
        <div class="game-item" v-for="(game, index) in gameList" :key="game.code || game.name || index" @click="showGameDetail(game)">
          <div class="game-icon" :class="[!game.iconUrl && (game.icon || 'system-icon-default')]">
            <img v-if="game.iconUrl" :src="game.iconUrl" :alt="game.name" />
          </div>
          <div class="game-info">
            <div class="game-name">{{ game.name }}</div>
            <div class="game-bet">{{ $t('Valid Bet') }} {{ fmtMoney(game.validBet) }}</div>
          </div>
          <div class="game-win-loss" :class="{ 'negative': game.winLoss < 0, 'positive': game.winLoss > 0 }">
            {{ fmtMoney(game.winLoss) }}
          </div>
          <div class="game-bets">
            {{ game.bets }}{{ $t('bets') }}
          </div>
        </div>
      </div>
      <div v-else style="margin-top: 60px; text-align: center">
        <img src="/static/image/mescroll-empty.png" style="width: 35%" alt="" />
        <van-divider dashed :style="{ color: '#ccc', borderColor: '#ccc', padding: '20px ' }">{{ $t('Empty') }}</van-divider>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'betRecord',
  data() {
    return {
      date: 1, // 默认选择今日
      list: [],
      pageData: {},
      page: 1,
      dogameLis: [],
      api_type: '',
      loading: false,
      name: '',
      show: false,
      totalBets: 0,
      validBet: 0,
      winLoss: 0,
      // 所有游戏平台列表 (保留游戏名原始中文或在此处也可用多语言，一般游戏品牌名可不翻译)
      allGames: [
        { name: 'PG电子', icon: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDg0Y2NiIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1kYXNoYXJyYXk9IjUgNSI+PHJlY3QgeD0iMiIgeT0iMiIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iMSIvPjxyZWN0IHg9IjYiIHk9IjYiIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIvPjwvc3ZnPg==' },
        { name: 'MG电子', icon: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDBhZmZmIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1kYXNoYXJyYXk9IjUgNSI+PHJlY3QgeD0iMiIgeT0iMiIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iMSIvPjxyZWN0IHg9IjYiIHk9IjYiIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIvPjwvc3ZnPg==' },
        { name: '乐游棋牌', icon: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1kYXNoYXJyYXk9IjUgNSI+PHJlY3QgeD0iMiIgeT0iMiIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iMSIvPjxyZWN0IHg9IjYiIHk9IjYiIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIvPjwvc3ZnPg==' },
        { name: 'BBIN真人', icon: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjc8OGNmQiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtZGFzaGFycmF5PSI1IDUiPjxwYXRoIGQ9Ik02IDEyYy0xLjIgMC0yLS44LTItMnMyLTIgMi0yIDItMiAyem0xMiAwYy0xLjIgMC0yLS44LTItMnMyLTIgMi0yIDItMiAyem0tNi02YzAtMS4yLjgtMiAyLTJzMi44IDIgMiAyLTIgMi0yLTJ6Ii8+PHJlY3QgeD0iMiIgeT0iMiIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iMSIvPjwvc3ZnPg==' },
        { name: 'BBIN电子', icon: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjc8OGNmQiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtZGFzaGFycmF5PSI1IDUiPjxwYXRoIGQ9Ik02IDEyYy0xLjIgMC0yLS44LTItMnMyLTIgMi0yIDItMiAyem0xMiAwYy0xLjIgMC0yLS44LTItMnMyLTIgMi0yIDItMiAyem0tNi02YzAtMS4yLjgtMiAyLTJzMi44IDIgMiAyLTIgMi0yLTJ6Ii8+PHJlY3QgeD0iMiIgeT0iMiIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iMSIvPjwvc3ZnPg==' },
        { name: 'CQ9电子', icon: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjY2MzZjQxIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1kYXNoYXJyYXk9IjUgNSI+PHJlY3QgeD0iMiIgeT0iMiIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iMSIvPjxyZWN0IHg9IjYiIHk9IjYiIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIvPjwvc3ZnPg==' },
        { name: '瓦力棋牌', icon: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNjY2ZmZmIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1kYXNoYXJyYXk9IjUgNSI+PHJlY3QgeD0iMiIgeT0iMiIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iMSIvPjxyZWN0IHg9IjYiIHk9IjYiIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIvPjwvc3ZnPg==' },
        { name: 'FG捕鱼', icon: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZDVkZjM1IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1kYXNoYXJyYXk9IjUgNSI+PHJlY3QgeD0iMiIgeT0iMiIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iMSIvPjxyZWN0IHg9IjYiIHk9IjYiIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIvPjwvc3ZnPg==' },
        { name: 'DG捕鱼', icon: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjYjhkZWEzIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1kYXNoYXJyYXk9IjUgNSI+PHJlY3QgeD0iMiIgeT0iMiIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iMSIvPjxyZWN0IHg9IjYiIHk9IjYiIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIvPjwvc3ZnPg==' },
        { name: 'MT捕鱼', icon: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIj999999IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1kYXNoYXJyYXk9IjUgNSI+PHJlY3QgeD0iMiIgeT0iMiIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iMSIvPjxyZWN0IHg9IjYiIHk9IjYiIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIvPjwvc3ZnPg==' }
      ],
      // 显示的游戏列表
      gameList: [],
      platformIconMap: {},
      // 平台选择下拉菜单显示状态
      showPlatformSelect: false
    };
  },
  computed: {
    // 状态数组移入 computed，跟随语言切换
    statuType() {
      return [this.$t('Invalid Bet'), this.$t('Settled'), this.$t('Unsettled')];
    },
    dateName() {
      return ['', this.$t('Today'), this.$t('Last 7 Days'), this.$t('Last 15 Days'), this.$t('Last 30 Days'), this.$t('Yesterday'), this.$t('This Week'), this.$t('Last Week')];
    },
    // 去除重复的平台
    uniquePlatforms() {
      let that = this;
      let seen = new Set();
      return that.allGames.filter(platform => {
        if (seen.has(platform.name)) {
          return false;
        }
        seen.add(platform.name);
        return true;
      });
    }
  },
  created() {
    let that = this;
    that.name = that.$t('All Platforms');
    that.getGamePlatforms();
  },
  methods: {
    fmtMoney(val) {
      const num = Number(val);
      return (Number.isFinite(num) ? num : 0).toFixed(2);
    },
    round2(val) {
      return Math.round((Number(val) || 0) * 100) / 100;
    },
    selectDate(val) {
      let that = this;
      that.date = val;
      that.page = 1;
      that.api_type = '';
      that.getData();
    },
    showGameDetail(game) {
      let that = this;
      // 筛选必须用 platform_type 编码（如 PGS），不能用中文名
      that.api_type = game.code || game.name || '';
      if (that.api_type === this.$t('All Platforms')) {
        that.api_type = '';
      }
      that.page = 1;
      that.getData();
    },
    selectPlatform(platform) {
      let that = this;
      that.api_type = platform === this.$t('All Platforms') ? '' : platform;
      that.showPlatformSelect = false;
      that.page = 1;
      that.getData();
    },
    // 获取投注记录
    getData() {
      let that = this;
      that.$parent.showLoading();
      let info = {
        date: that.date,
        page: 1,
        pagesize: 500,
        api_type: that.api_type,
      };
      that.$apiFun
        .post('/api/betrecord', info)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.pageData = res.data;
            that.list = res.data.data || [];
            that.calculateGameStats(that.list);
            that.page = 2;
          }
          that.loading = false;
          that.$parent.hideLoading();
        })
        .catch(() => {
          that.$parent.hideLoading();
          that.loading = false;
        });
    },
    // 计算游戏统计信息：按 platform_type 聚合，只展示有数据的平台
    calculateGameStats(data) {
      let that = this;
      that.totalBets = 0;
      that.validBet = 0;
      that.winLoss = 0;
      const gameGroups = {};
      const rows = Array.isArray(data) ? data : [];

      rows.forEach(item => {
        that.totalBets += 1;
        const valid = parseFloat(item.valid_amount != null ? item.valid_amount : item.bet_amount) || 0;
        const wl = parseFloat(item.win_loss) || 0;
        that.validBet += valid;
        that.winLoss += wl;

        const code = String(item.platform_type || item.Code || 'OTHER');
        const key = code.toUpperCase();
        const displayName = item.Code || item.platform_type || that.$t('Other');
        if (!gameGroups[key]) {
          const matched = that.allGames.find(g => {
            const n = String(g.name || '');
            const c = String(g.code || g.platname || '').toUpperCase();
            return n === displayName || c === key || n.toUpperCase() === key || n === code;
          });
          gameGroups[key] = {
            name: (matched && matched.name) || displayName,
            code: key,
            icon: matched ? matched.icon : that.getGameIcon(displayName),
            iconUrl: (matched && matched.iconUrl) || that.resolvePlatformIcon(key, displayName),
            validBet: 0,
            winLoss: 0,
            bets: 0
          };
        }
        gameGroups[key].validBet += valid;
        gameGroups[key].winLoss += wl;
        gameGroups[key].bets += 1;
      });

      that.validBet = that.round2(that.validBet);
      that.winLoss = that.round2(that.winLoss);

      let gameList = Object.values(gameGroups)
        .map(g => ({
          ...g,
          validBet: that.round2(g.validBet),
          winLoss: that.round2(g.winLoss)
        }))
        .filter(g => g.bets > 0)
        .sort((a, b) => b.bets - a.bets);

      if (that.api_type) {
        const filterKey = String(that.api_type).toUpperCase();
        gameList = gameList.filter(game =>
          String(game.code || '').toUpperCase() === filterKey ||
          game.name === that.api_type
        );
      }
      that.gameList = gameList;
    },
    // 获取游戏平台列表
    getGamePlatforms() {
      let that = this;
      that.$apiFun.post('/api/balancelist', {}).then(res => {
        if (res.code == 200) {
          const platforms = (res.data || []).map(item => ({
            name: item.name,
            code: item.platname || '',
            platname: item.platname || '',
            icon: that.getGameIcon(item.name),
            iconUrl: item.app_icon || ''
          }));
          that.platformIconMap = {};
          platforms.forEach(p => {
            if (p.code) that.platformIconMap[String(p.code).toUpperCase()] = p.iconUrl || '';
            if (p.name) that.platformIconMap[p.name] = p.iconUrl || '';
          });
          // PGS 未配置图标时回退到 PG
          if (!that.platformIconMap.PGS && that.platformIconMap.PG) {
            that.platformIconMap.PGS = that.platformIconMap.PG;
            platforms.forEach(p => {
              if (String(p.code).toUpperCase() === 'PGS' && !p.iconUrl) {
                p.iconUrl = that.platformIconMap.PG;
              }
            });
          }
          platforms.unshift({
            name: that.$t('All Platforms'),
            code: '',
            platname: '',
            icon: 'system-icon-default',
            iconUrl: ''
          });
          that.allGames = platforms;
          that.getData();
        } else {
          that.loadDefaultGames();
        }
      }).catch(() => {
        that.loadDefaultGames();
      });
    },
    loadDefaultGames() {
      let that = this;
      that.allGames = [
        { name: that.$t('All Platforms'), code: '', icon: 'system-icon-default', iconUrl: '' },
        { name: 'PG电子', code: 'PG', icon: that.getGameIcon('PG电子'), iconUrl: '' },
        { name: 'PGS电子', code: 'PGS', icon: that.getGameIcon('PG电子'), iconUrl: '' },
        { name: 'MG电子', code: 'MG', icon: that.getGameIcon('MG电子'), iconUrl: '' },
        { name: '乐游棋牌', code: 'LY', icon: that.getGameIcon('乐游棋牌'), iconUrl: '' },
        { name: 'BBIN真人', code: 'BBIN', icon: that.getGameIcon('BBIN真人'), iconUrl: '' },
        { name: 'CQ9电子', code: 'CQ9', icon: that.getGameIcon('CQ9电子'), iconUrl: '' }
      ];
      that.getData();
    },
    resolvePlatformIcon(code, name) {
      const map = this.platformIconMap || {};
      const key = String(code || '').toUpperCase();
      if (map[key]) return map[key];
      if (map[name]) return map[name];
      if (key.indexOf('PG') === 0 && map.PG) return map.PG;
      return '';
    },
    getGameIcon(gameName) {
      const icons = {
        'PG电子': 'system-icon-pg',
        'PGS电子': 'system-icon-pg',
        'MG电子': 'system-icon-mg',
        '乐游棋牌': 'system-icon-leyou',
        'BBIN真人': 'system-icon-bbin-live',
        'BBIN电子': 'system-icon-bbin-slot',
        'CQ9电子': 'system-icon-cq9',
        '瓦力棋牌': 'system-icon-wali',
        'FG捕鱼': 'system-icon-fg',
        'DG捕鱼': 'system-icon-dg',
        'MT捕鱼': 'system-icon-mt',
        'FB体育': 'system-icon-fb'
      };
      return icons[gameName] || 'system-icon-default';
    },
  },
  mounted() {
    let that = this;
    // 添加点击外部关闭平台选择下拉菜单的事件监听器
    document.addEventListener('click', function(e) {
      const platformSelectBtn = document.querySelector('.platform-select-btn');
      const platformSelectDropdown = document.querySelector('.platform-select-dropdown');
      if (platformSelectBtn && platformSelectDropdown && !platformSelectBtn.contains(e.target) && !platformSelectDropdown.contains(e.target)) {
        that.showPlatformSelect = false;
      }
    });
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
/* 日期筛选样式 */
.date-filter {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  .date-item {
    flex: 1;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 0.26rem; /* 稍微缩小字号兼容英文 */
    color: #333;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    margin: 0 5px;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
    &.active {
      background-color: #3d72fa;
      color: white;
      border-color: #3d72fa;
    }
  }
}

/* 总计信息样式 */
.total-info {
  display: flex;
  justify-content: space-between;
  padding: 15px;
  background-color: #f5f5f5;
  border-radius: 8px;
  margin-bottom: 15px;
  .total-item {
    flex: 1;
    text-align: center;
    .total-label {
      display: block;
      font-size: 0.26rem;
      color: #666;
      margin-bottom: 5px;
    }
    .total-value {
      display: block;
      font-size: 0.32rem;
      color: #333;
      font-weight: bold;
      &.negative {
        color: #52c41a;
      }
      &.positive {
        color: #ff4d4f;
      }
    }
  }
}

/* 游戏列表样式 */
.game-list {
  .game-item {
    display: flex;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #f0f0f0;
    &:last-child {
      border-bottom: none;
    }
    .game-icon {
      width: 40px;
      height: 40px;
      margin-right: 15px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      overflow: hidden;
      background: #f2f3f5;
      flex-shrink: 0;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
      &.system-icon-pg {
        background-color: #084ccb;
        color: white;
      }
      &.system-icon-mg {
        background-color: #00afff;
        color: white;
      }
      &.system-icon-leyou {
        background-color: #ffffff;
        color: #000000;
        border: 1px solid #e0e0e0;
      }
      &.system-icon-bbin-live {
        background-color: #c8ecfb;
        color: #000000;
      }
      &.system-icon-bbin-slot {
        background-color: #c8ecfb;
        color: #000000;
      }
      &.system-icon-cq9 {
        background-color: #cccf41;
        color: white;
      }
      &.system-icon-wali {
        background-color: #666fff;
        color: white;
      }
      &.system-icon-fg {
        background-color: #d5df35;
        color: white;
      }
      &.system-icon-dg {
        background-color: #b8dea3;
        color: white;
      }
      &.system-icon-mt {
        background-color: #999999;
        color: white;
      }
      &.system-icon-fb {
        background-color: #1877f2;
        color: white;
      }
      &.system-icon-default {
        background-color: #999999;
        color: white;
      }
    }
    .game-info {
      flex: 1;
      .game-name {
        font-size: 0.32rem;
        color: #333;
        margin-bottom: 5px;
      }
      .game-bet {
        font-size: 0.26rem;
        color: #666;
      }
    }
    .game-win-loss {
      font-size: 0.32rem;
      color: #333;
      font-weight: bold;
      margin-right: 15px;
      &.negative {
        color: #52c41a;
      }
      &.positive {
        color: #ff4d4f;
      }
    }
    .game-bets {
      font-size: 0.26rem;
      color: #666;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/betRecord.vue